export default "__VITE_ASSET__CuHZPZ35__"